import holidayService from '../../../common/service/holidayService';

const FROM_CITIES_API = '/searchcity/getDepartureCities';

export const getFromCities = () => {
  const url = FROM_CITIES_API;
  return holidayService.get(url, {});
};
